import { render } from "./NotificationToast.vue?vue&type=template&id=5dbdae28"
import script from "./NotificationToast.vue?vue&type=script&lang=js"
export * from "./NotificationToast.vue?vue&type=script&lang=js"

import "./NotificationToast.vue?vue&type=style&index=0&id=5dbdae28&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__